$(function(){
    // ACCORDION
    $('.acc header').click(function(){
        var parent = $(this).parent();
        parent.siblings().find('footer').hide();
        parent.siblings().removeClass('active');
        parent.toggleClass('active');
        parent.find('footer').stop().slideToggle();
    });


    // ACCORDION Toggle 2
    $('.listBlock a.cta').click(function(){
        var parent = $(this).parent();
        parent.find('.content .details').slideToggle();
    });

    // ACCORDION
    $('.halfBlock header').click(function(){
        var parent = $(this).parent();
        parent.siblings().find('ul').hide();
        parent.siblings().removeClass('active');
        parent.toggleClass('active');
        parent.find('ul').stop().slideToggle();
    });

    // Search Bar Functionality
    var searchBtn = $('.search .searchBtn');

    searchBtn.click(function(){
        $(this).closest('.search').toggleClass('searchActive');
        $(this).siblings('.searchBox').find('form input[type="text"]').focus();
    });


    // Equalize product block heights
    $('.productBlocks, .gridBlocks').imagesLoaded(function(){
        $(window).resize(function(){
            equalize($('.productBlocks:not(.gridBlocks):not(.threeBlock)'), $('.product') );
            equalize($('.gridBlocks:not(.gridBlocks):not(.threeBlock)'), $('.item') );
        }).resize();
    });


    // If prevous page is 
    $('.previousPage').each(function(){
        if (document.referrer == window.location.origin) {
            $(this).show();
            $(this).click(function(event){
                event.preventDefault();
                window.history.back();
            });
        } else {
            $(this).hide();
        }
    });

    // Team info panels
    var teamProfile = $('.teamMeetup .profile .action');

    teamProfile.click(function(){
        var parent = $(this).parent();

        if ( parent.hasClass('active') ) {
            parent.removeClass('active');
            parent.siblings().removeClass('disabled');
        } else {
            parent.addClass('active').siblings().addClass('disabled');
        }
    });
});


// Latest NEW Slider
$(function() {
    var mainCarousel = $('div.ticker');

    mainCarousel.imagesLoaded(function(){
        mainCarousel.flickity({
            cellAlign: 'center',
            groupCells: true,
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            autoPlay: false,
            wrapAround: true,
            arrowShape: { 
                x0: 20,
                x1: 55, y1: 50,
                x2: 60, y2: 50,
                x3: 25
            }
        });
    });

});

//Responsiv Tabs with Mobile Accordion Mode
$(document).ready(function() {
    //Horizontal Tab
    $('#parentHorizontalTab').easyResponsiveTabs({
        type: 'default', //Types: default, vertical, accordion
        width: 'auto', //auto or any width like 600px
        fit: true, // 100% fit in a container
        tabidentify: 'hor_1', // The tab groups identifier
        activate: function(event) { // Callback function if tab is switched
            var $tab = $(this);
            var $info = $('#nested-tabInfo');
            var $name = $('span', $info);
            $name.text($tab.text());
            $info.show();
        }
    });        
});


//download all file
$(function() {
   $("#btnDownloadAll").click(function (e) {
       e.preventDefault();

       var linkArray = [];
       $("ul.pdfList li a").each(function () {
           var t = $(this).attr("href");
           linkArray.push({ path: t, name: t } );
       });
       
       var temporaryDownloadLink = document.createElement("a");
       temporaryDownloadLink.style.display = 'none';

       document.body.appendChild(temporaryDownloadLink);

       for (var n = 0; n < linkArray.length; n++) {
           var download = linkArray[n];
           temporaryDownloadLink.setAttribute('href', download.path);
           temporaryDownloadLink.setAttribute('download', download.name);

           temporaryDownloadLink.click();
       }

       document.body.removeChild(temporaryDownloadLink);
   });
});


